import { render, staticRenderFns } from "./StockProductsOverview.vue?vue&type=template&id=210fa9ca&"
import script from "./StockProductsOverview.vue?vue&type=script&lang=js&"
export * from "./StockProductsOverview.vue?vue&type=script&lang=js&"
import style0 from "./StockProductsOverview.vue?vue&type=style&index=0&id=210fa9ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports